export enum ContentTypes {
    TOGGLE_MENU = '@@/content/toggle_menu',

}